import colors from 'styles/themes/colors';

const getShortFormVideoColors = (platfrom?: number): string[] => {
  switch (platfrom) {
    // WeSee
    case 289673:
      return ['#5F39F3', '#FC3EAF'];
    // YouTube Shorts
    case 291943:
      return ['#FF0000', '#212121'];
    // TikTok or Douyin
    case 285185:
    case 285184:
      return [colors.Aquamarine, colors.DarkRose];
    default:
      return [colors.Blue, colors.CanaryYellow];
  }
};

export default getShortFormVideoColors;
